import React, { useContext, useState } from "react";
import { CheckCircle2, Circle, Clock, Check } from "lucide-react";
import { toast } from "sonner";
import { LearnCtx, REACTIONS } from "../lib/learn";

const Feedback = ({ it, learn, accent, onDone }) => {
  const [reaction, setReaction] = useState(null);
  const [note, setNote] = useState("");
  const [named, setNamed] = useState(false);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await learn.sendFeedback(it.id, reaction, note.trim(), !named); toast.success("Thanks, your feedback was sent to the teacher"); onDone(); } catch { window.alert("Couldn't send, please try again."); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 border border-white/10 bg-white/5 p-3 space-y-2" data-testid={`lesson-feedback-${it.id}`}>
      <div className="font-body text-sm text-white">How was this lesson? <span className="text-zinc-500 text-xs">Optional</span></div>
      <div className="flex flex-wrap gap-1.5">
        {REACTIONS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setReaction(reaction === k ? null : k)} data-testid={`lesson-reaction-${k}`}
            className="inline-flex items-center gap-1 border px-2.5 py-1 font-body text-xs transition-colors" style={reaction === k ? { borderColor: accent, color: "#0A0A0A", background: accent } : { borderColor: "rgba(255,255,255,0.15)" }}>{reaction === k && <Check size={11} />}{l}</button>
        ))}
      </div>
      <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={2000} placeholder="Anything you'd like the teacher to know? (optional)" data-testid="lesson-feedback-note"
        className="w-full bg-[#0A0A0A] border border-white/10 px-2 py-1.5 font-body text-sm text-white outline-none focus:border-white/30" />
      <label className="flex items-center gap-1.5 font-body text-xs text-zinc-400"><input type="checkbox" checked={named} onChange={(e) => setNamed(e.target.checked)} data-testid="lesson-feedback-named" /> Include my name (otherwise it's anonymous)</label>
      <div className="flex gap-2">
        <button type="button" onClick={send} disabled={busy || (!reaction && !note.trim())} data-testid="lesson-feedback-send" className="px-3 py-1.5 font-body text-xs font-semibold disabled:opacity-40" style={{ background: accent, color: "#0A0A0A" }}>Send feedback</button>
        <button type="button" onClick={onDone} data-testid="lesson-feedback-skip" className="px-3 py-1.5 font-body text-xs text-zinc-400 hover:text-white">Skip</button>
      </div>
    </div>
  );
};

// Bottom of each lesson: duration, Mark complete, then an optional feedback card.
export const LessonComplete = ({ it, accent }) => {
  const learn = useContext(LearnCtx);
  const [skipped, setSkipped] = useState(false);
  const [justDone, setJustDone] = useState(false);
  if (!learn && !it.duration) return null;
  const done = learn?.done.has(it.id);
  return (
    <div className="mt-2">
      <div className="flex items-center gap-3">
        {learn && (
          <button type="button" onClick={() => { learn.mark(it.id, !done); setJustDone(!done); }} data-testid={`lesson-complete-${it.id}`}
            className="inline-flex items-center gap-1.5 font-body text-xs transition-colors" style={{ color: done ? accent : undefined }}>
            {done ? <CheckCircle2 size={15} /> : <Circle size={15} className="text-zinc-500" />}{done ? "Completed" : "Mark complete"}
          </button>
        )}
        {it.duration && <span className="inline-flex items-center gap-1 font-body text-[11px] text-zinc-500" data-testid={`lesson-duration-${it.id}`}><Clock size={11} />{it.duration}</span>}
      </div>
      {learn && done && justDone && !skipped && !learn.feedback[it.id] && <Feedback it={it} learn={learn} accent={accent} onDone={() => setSkipped(true)} />}
    </div>
  );
};
